import React from "react";

const Footer = () => (
  <footer className="bg-white border-t mt-12 py-4">
    <div className="container mx-auto px-4 flex flex-col sm:flex-row flex-wrap items-center justify-center gap-x-8 gap-y-2 text-gray-700 text-sm font-medium">
      <span>
        <span className="font-semibold">Phone:</span>{" "}
        <a href="tel:571-617-3225" className="hover:underline">
          571-617-3225
        </a>
      </span>
      <span className="block sm:inline text-center sm:text-left">
        <span className="font-semibold">Mailing Address:</span> 1441 E. Broad
        St., Ste 342, Fuquay-Varina, NC 27526, USA
      </span>
      <span>
        <a
          href="https://instagram.com/kickinwcrews"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center space-x-2 hover:text-indigo-600"
        >
          <span className="font-semibold">Social Media:</span>{" "}
          <svg
            width="28"
            height="28"
            viewBox="0 0 448 448"
            className="inline-block"
          >
            <defs>
              <linearGradient
                id="ig-gradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
              >
                <stop offset="0%" stopColor="#f58529" />
                <stop offset="30%" stopColor="#dd2a7b" />
                <stop offset="60%" stopColor="#8134af" />
                <stop offset="100%" stopColor="#515bd4" />
              </linearGradient>
            </defs>
            <rect
              x="32"
              y="32"
              width="384"
              height="384"
              rx="90"
              fill="url(#ig-gradient)"
            />
            <circle
              cx="224"
              cy="224"
              r="80"
              fill="none"
              stroke="#fff"
              strokeWidth="40"
            />
            <circle cx="336" cy="112" r="24" fill="#fff" />
          </svg>
          <span>@kickinwcrews</span>
        </a>
      </span>
      <span>
        <a
          href="/privacy-policy.html"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          Privacy Policy
        </a>
      </span>
    </div>
  </footer>
);

export default Footer;
